// components/StepProgress.jsx
import React from 'react';
import './StepProgress.css';
import { GetImages } from '../../../../utils/GetImages';

const StepProgress = ({ title, steps, progress }) => {
  return (
    <div className="step-progress">
      <p className="normal_text step-progress__title">{title}</p>
      <div className="step-progress__bar">
        <div className="step-progress__bar-fill" style={{ width: `${progress}%` }} />
        <span className="step-progress__bar-text">{progress}%</span>
      </div>
       <ul className="step-progress__list">
        {steps?.map((step, index) => {
          const isCompleted = step.completed;
          const isCurrent = step.current;
          const isLast = index === steps.length - 1;
          const nextStepCompleted = steps[index + 1]?.completed;

          return (
            <li key={index} className="step-progress__step-item">
              {/* vertical connector line */}
              {!isLast && (
                <div
                  className={`step-progress__line ${
                    isCompleted && nextStepCompleted
                      ? 'step-progress__line--blue'
                      : 'step-progress__line--gray'
                  }`}
                />
              )}
              {/* step icon */}
              <div
                className={`step-progress__icon ${
                  isCompleted ? 'completed' : ''
                } ${isCurrent ? 'current' : ''}`}
              >
                {isCompleted && (
    <img
      src={GetImages.WhiteRight}
      alt="completed"
      // className="iconstyle10"
      width={"8px"}
      height={"8px"}
    />
  )}
                {/* {isCompleted ? '✓' : ''} */}
              </div>

              {/* step label */}
              <span
                className={`step-progress__label ${
                  isCurrent ? 'current' : isCompleted ? 'completed' : ''
                }`}
              >
                {step.label}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default StepProgress;
